/** Copy shader — trivial 1:1 texture blit.
 *  Used for resolution scaling, layer duplication, and pixel readback conversions. */

export const copyVertexShader = /*glsl*/`
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = vec4(position, 1.0);
  }
`;

export const copyFragmentShader = /*glsl*/`
  precision highp float;
  varying vec2 vUv;
  uniform sampler2D uTex;
  void main() {
    gl_FragColor = texture(uTex, vUv);
  }
`;
